export default function JobsController(
  $scope,
  $filter,
  $uibModal,
  JobSchedulerService,
  gettextCatalog,
) {
  'ngInject';

  $scope.disableView = false;
  $scope.errorFlag = false;
  $scope.loading = true;
  $scope.query = '';
  $scope.schedule = {};

  //defualt onei3 schedule report tag
  $scope.tag = 'onei3:schedule:report';

  //Local Variables
  $scope.search = {
    text: '',
  };
  $scope.schedules = [];
  $scope.filteredSchedules = [];
  $scope.schedulesByPage = [];
  //Sorting
  $scope.predicate = 'jobName';
  $scope.reverse = true;
  var orderBy = $filter('orderBy');

  //Pagination
  $scope.currentPage = 1;
  $scope.itemsPerPage = 25;
  $scope.maxSize = 3;

  //Sort filteredSchedules
  $scope.orderSchedule = function (predicate, toggle) {
    $scope.reverse = $scope.predicate === predicate ? !$scope.reverse : toggle;
    $scope.predicate = predicate;
  };

  var isAllChecked = function (schedulesInPage) {
    var bool = true;
    for (var i = 0; i < schedulesInPage.length; i++) {
      if (
        schedulesInPage[i].checkForRemoval == undefined ||
        schedulesInPage[i].checkForRemoval == false
      ) {
        bool = false;
        break;
      }
    }
    return bool;
  };

  $scope.checkAllFilteredSchedulesforRemoval = function () {
    if ($scope.selectedAll) {
      $scope.selectedAll = true;
    } else {
      $scope.selectedAll = false;
    }
    angular.forEach($scope.schedulesByPage, function (schedule) {
      schedule.checkForRemoval = $scope.selectedAll;
    });
  };
  $scope.applyChange = function () {
    $scope.selectedAll = isAllChecked($scope.schedulesByPage);
  };

  $scope.getNotificationEmails = function (schedule) {
    return JobSchedulerService.getNotificationEmails(schedule);
  };

  $scope.pageChanged = function () {
    $scope.selectedAll = isAllChecked($scope.schedulesByPage);
  };

  //applyFilter searchs the Schedules[] for anything matching the search input.
  $scope.applyFilter = function () {
    $scope.filteredSchedules = $filter('filter')($scope.schedules, $scope.search.text);
  };
  $scope.disableRemoveButton = function () {
    var bool = true;
    for (var i = 0; i < $scope.schedules.length; i++) {
      if ($scope.schedules[i].checkForRemoval == true) {
        bool = false;
        break;
      }
    }
    return bool;
  };

  $scope.search = function (schedule) {
    if ($scope.query.length <= 0) return true;
    var query = ('' + $scope.query).toLowerCase(),
      fullname = [schedule.name].join(' ').toLowerCase();
    return fullname.indexOf(query) > -1;
  };

  $scope.order = function (predicate) {
    $scope.reverse = $scope.predicate === predicate ? !$scope.reverse : false;
    $scope.predicate = predicate;
  };

  $scope.removeSelectedButtonPressed = function () {
    $scope.disableView = true;
    angular.forEach($scope.schedules, function (schedule) {
      if (schedule.checkForRemoval == true) {
        JobSchedulerService.deleteSchedule(schedule);
      }
    });
    setTimeout(refreshSchedules, 2000);
  };

  $scope.deleteSelected = function (scheduleToDelete) {
    var modalInstance = $uibModal.open({
      animation: true,
      keyboard: false,
      backdrop: 'static',
      template: require('./_delete.schedule.confirmation.modal.html'),
      controller: function ($scope, $uibModalInstance, $state, scheduleToDelete) {
        $scope.loading = false;
        $scope.errorFlag = false;
        $scope.errorText = '';
        $scope.schedule = scheduleToDelete;

        $scope.ok = function () {
          $scope.loading = true;

          JobSchedulerService.deleteSchedule(scheduleToDelete)
            .then(
              function (response) {
                $uibModalInstance.close(scheduleToDelete);
              },
              function (response) {
                $uibModalInstance.dismiss(gettextCatalog.getString('Error deleting schedule'));
                $scope.errorFlag = true;
              },
            )
            .finally(function (result) {
              $scope.loading = false;
            });
        };
        $scope.cancel = function () {
          $uibModalInstance.dismiss('cancel');
        };
      },
      size: 'sm',
      resolve: {
        scheduleToDelete: function () {
          return scheduleToDelete;
        },
      },
    });
    modalInstance.result.then(
      function (scheduleToDelete) {
        refreshSchedules();
      },
      function (result) {
        $scope.$broadcast('refreshSchedules', true);
      },
    );
  };

  var refreshSchedules = function () {
    $scope.loading = true;

    JobSchedulerService.getSchedules($scope.tag)
      .then(
        function (response) {
          $scope.schedules = response.data.data;
          $scope.filteredSchedules = $scope.schedules.slice();
          $scope.disableView = false;
          //add additional properties to the filteredSchedules
          angular.forEach($scope.filteredSchedules, function (schedule) {
            schedule.checkForRemoval = false;
            schedule.recurrence = schedule.recurrence.frequency;
            schedule.emails = $scope.getNotificationEmails(schedule);
          });
          $scope.orderSchedule($scope.predicate, $scope.reverse);
        },
        function (response) {
          $scope.errorFlag = true;
          $scope.errorText = gettextCatalog.getString(
            'Sorry for the inconvenience. The scheduler service is down. Please try again later.',
          );
        },
      )
      .finally(function () {
        $scope.loading = false;
      });
  };
  refreshSchedules();
  $scope.$on('refreshSchedules', function (event, data) {
    refreshSchedules();
  });

  //modal overlay update schedule
  $scope.updateSchedule = function (schedule) {
    var modalInstance = $uibModal.open({
      animation: true,
      keyboard: false,
      backdrop: 'static',
      template: require('./job/job.update.html'),
      controller: 'JobCreateController',
      size: 'lg',
      resolve: {
        scheduleAttributes: function () {
          return $scope.schedule;
        },
      },
    });
    modalInstance.result.then(
      function (scheduleAttributes) {
        refreshSchedules();
      },
      function () {
        console.log('update error');
        $scope.$broadcast('refreshSchedules', true);
      },
    );
  }; //modal overlay update schedule

  //modal overlay create schedule
  $scope.createSchedule = function () {
    var modalInstance = $uibModal.open({
      animation: true,
      keyboard: false,
      backdrop: 'static',
      template: require('./job/job.create.html'),
      controller: 'JobCreateController',
      size: 'lg',
      resolve: {
        scheduleAttributes: function () {
          return $scope.schedule;
        },
      },
    });
    modalInstance.result.then(
      function (scheduleAttributes) {
        refreshSchedules();
      },
      function () {},
    );
  }; // end modal overlay create schedule

  $scope.formatDate = function (date) {
    // return date;
    if (date == undefined) return '';
    var date = new Date(date);
    var strDate = toJSONLocal(date);
    strDate = strDate.split('-');
    return strDate[1] + '/' + strDate[2] + '/' + strDate[0] + ' ' + formatTime(date);
  };

  function toJSONLocal(date) {
    var local = new Date(date);
    local.setMinutes(date.getMinutes() - date.getTimezoneOffset());
    return local.toJSON().slice(0, 10);
  }

  function toLocal(date) {
    var local = new Date(date);
    local.setMinutes(date.getMinutes() - date.getTimezoneOffset());
    return local.toJSON();
  }

  function formatTime(dateObj) {
    // formats a javascript Date object into a 12h AM/PM time string
    var hour = dateObj.getHours();
    var minute = dateObj.getMinutes();
    var amPM = hour > 11 ? ' PM' : ' AM';
    if (hour > 12) {
      hour -= 12;
    } else if (hour == 0) {
      hour = '12';
    }
    if (minute < 10) {
      minute = '0' + minute;
    }
    if (hour < 10) {
      hour = '0' + hour;
    }
    return hour + ':' + minute + amPM;
  }
}
